'use strict';
import angular from 'angular';
import SearchBoxController from './search-box.controller';
import { MdAutocompleteModule } from './MdAutocomplete/MdAutocomplete.module';
import RecommendedProductsService from '../../app/search/recommended-products.service';
import { RecommendedFlyout } from './recommended-flyout/recommended-flyout.module';
export default angular
    .module('directives.shipingOptions', [
    MdAutocompleteModule,
    RecommendedFlyout
])
    .controller('SearchBoxController', SearchBoxController)
    .controller('SearchBoxController', SearchBoxController)
    .service('RecommendedProductsService', RecommendedProductsService)
    .component('searchBox', {
    template: require('./search-box.html'),
    controller: SearchBoxController
})
    .name;
//# sourceMappingURL=index.js.map